import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {deletedNewYear} from '../store/slice';
import deletePartnerCostEntryYearMutation from '../graphql/deletePartnerCostEntryYearMutation';
import {PartnerCostEntryYear} from '../store/types';

interface UseDeletePartnerCostEntryYearResult {
  deletePartnerCostEntryYear: (
    partnerId: string,
    year: number,
    onSuccess: (year: number) => void
  ) => Promise<void>;
}

export const useDeletePartnerCostEntryYear =
  (): UseDeletePartnerCostEntryYearResult => {
    const dispatch = useAppDispatch();

    const [deleteMutation] = useMutation<{
      deleteBusPartnerCostEntryYear: PartnerCostEntryYear;
    }>(deletePartnerCostEntryYearMutation, {
      errorPolicy: 'all'
    });

    const deletePartnerCostEntryYear = useCallback(
      async (
        partnerId: string,
        year: number,
        onSuccess: (year: number) => void
      ) => {
        try {
          const {data, errors} = await deleteMutation({
            variables: {partnerId, year}
          });

          if (errors && errors.length > 0) {
            const errorMessage =
              errors[0]?.extensions?.errorMessage ?? errors[0].message;
            console.error(
              'Delete partner cost entry year error:',
              errorMessage
            );
            return;
          }

          if (data?.deleteBusPartnerCostEntryYear) {
            dispatch(deletedNewYear({busPartnerId: partnerId, year}));
            onSuccess(year);
          }
        } catch (error) {
          const errorMessage = `Unexpected error while deleting partner cost entry year: ${error}`;
          console.error(errorMessage);
        }
      },
      [deleteMutation, dispatch]
    );

    return {deletePartnerCostEntryYear};
  };
